import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CompassIcon, MusicIcon, SpeakerIcon, LeafIcon, SparklesIcon, HeartIcon, SunIcon, MoonIcon } from './Icons';
import './Header.css';

const Header = ({ currentPage, setCurrentPage, darkMode, toggleDarkMode, favoritesCount, selectedCategory, setSelectedCategory }) => {
  const navigate = useNavigate();
  
  const categories = [
    { id: 'all', name: 'Découvrir', Icon: CompassIcon },
    { id: 'Effets sonores', name: 'Effets sonores', Icon: SpeakerIcon },
    { id: 'Nature', name: 'Nature', Icon: LeafIcon },
    { id: 'Ambiance', name: 'Ambiance', Icon: SparklesIcon },
  ];
  
  const handleCategoryClick = (categoryId) => {
    // Déléguer la logique de navigation et de réinitialisation au composant parent (App).
    // Cela permet, entre autres, de revenir à la vue des sous-catégories
    // lorsqu’on clique sur une catégorie déjà active.
    setSelectedCategory(categoryId);
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo-section">
          <div className="logo">
            <img src="/logo192.png" alt="SoundNest Logo" className="logo-img" />
            <h1 className="logo-text">SoundNest</h1>
          </div>
        </div>

        <nav className="main-navigation">
          {categories.map(({ id, name, Icon }) => (
            <button 
              key={id}
              className={`nav-category ${selectedCategory === id ? 'active' : ''}`}
              onClick={() => handleCategoryClick(id)}
            >
              <span className="category-icon"><Icon /></span>
              <span className="category-name">{name}</span>
            </button>
          ))}
        </nav>

        <div className="header-actions">
          <button 
            className={`favorites-btn ${currentPage === 'favorites' ? 'active' : ''}`}
            onClick={() => navigate('/favorites')}
            title="Mes favoris"
          >
            <span className="favorites-icon"><HeartIcon filled={currentPage === 'favorites'} /></span>
            {favoritesCount > 0 && (
              <span className="favorites-count">{favoritesCount}</span>
            )}
          </button>
          
          <button 
            className="theme-toggle"
            onClick={toggleDarkMode}
            title={darkMode ? 'Mode clair' : 'Mode sombre'}
          >
            <span className="theme-icon">
              {darkMode ? <SunIcon /> : <MoonIcon />}
            </span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
